import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "c-modal",
  id: "modal-angebot-per-mail"
}
const _hoisted_2 = { class: "c-modal__content" }
const _hoisted_3 = { class: "c-modal__header" }
const _hoisted_4 = { class: "c-modal__title" }
const _hoisted_5 = { class: "c-modal__content-section u-text-align-left" }
const _hoisted_6 = { class: "o-grid o-grid--align-middle" }
const _hoisted_7 = { class: "o-grid__cell o-grid__cell--1" }
const _hoisted_8 = { class: "o-grid__cell o-grid__cell--6 form-actions u-mar-b-0 u-text-align-left" }
const _hoisted_9 = { class: "o-grid__cell o-grid__cell--6 form-actions u-mar-b-0 u-text-align-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_sprite = _resolveComponent("icon-sprite")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, [
          _renderSlot(_ctx.$slots, "titel", {}, () => [
            _cache[3] || (_cache[3] = _createTextVNode("Verzögerte Antwort"))
          ])
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "c-button c-button--icon-only-white",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
        }, [
          _createVNode(_component_icon_sprite, { "icon-name": "icon-cross" }),
          _cache[4] || (_cache[4] = _createElementVNode("span", { class: "c-button__visually-hidden" }, "close", -1))
        ])
      ]),
      _createElementVNode("section", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_icon_sprite, {
              "icon-name": "icon-delete-item",
              "ist-gross": true,
              "css-style": "color: red"
            })
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "o-grid__cell o-grid__cell--11" }, [
            _createTextVNode(" Die Antwort auf eine Anfrage im Hintergrund dauerte länger als erwartet."),
            _createElementVNode("br"),
            _createTextVNode(" Wollen Sie es erneut versuchen? ")
          ], -1)),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              class: "c-button c-button--inverted",
              type: "button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeModal()))
            }, "Abbrechen")
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              class: "c-button right",
              type: "button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.erneutVersuchen()))
            }, "Erneut versuchen")
          ])
        ])
      ])
    ])
  ]))
}